import React from 'react';
import type { FC } from 'react';
import { Container, Stack } from '@mui/material';
import { AvailableVersions } from '../AvailableVersions';
import { Header } from '../Header';
import { Changelog } from '../Changelog';

export const Home: FC = () => {
  return (
    <Container sx={{ mt: 3 }}>
      <Stack spacing={3}>
        <Header title={process.env.REACT_APP_HEADER ?? 'VoiSmart App'} />
        <AvailableVersions />
        <Changelog />
      </Stack>
    </Container>
  );
};
